import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-corner-vacant-property',
  templateUrl: './corner-vacant-property.component.html',
  styleUrls: ['./corner-vacant-property.component.css']
})
export class CornerVacantPropertyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/corner-vacant-property/corner-vacant-property.component.ts